import React, { PropTypes } from 'react'
import { Router, Route } from 'dva/router'
import {env} from './utils/config'
import HomePage from './components/homePage/Index'

// ================================================login
import Login from './components/login/Login'

// ============================================MainLayout

import {Wrapper, config, Auth} from '@qianli/dashboard-common-layout'
//import { Wrapper } from '@qianli/dashboard-common-layout'
//import Auth from './lib/auth'

let auth = new Auth(env)
const requireAuth = auth.requireAuth.bind(auth)

window.addEventListener('hashchange', function(e){console.log('-----location.href------:', location.href)});

export default function ({history}) {
  return (
    <Router history={history}>

      <Route path='/login' component={Login}/>
      <Route path='/homePage' component={HomePage} onEnter={requireAuth} />

      <Route path='/' component={HomePage} onEnter={requireAuth} />

      {/* <Route path='/' component={Wrapper({history, env, module: 'login', onChangeModule: module => {console.log(module)}})} onEnter={requireAuth} /> */}
    </Router>
  )
};



/** WEBPACK FOOTER **
 ** ./src/router.js
 **/